export default __webpack_public_path__ + "static/media/pdf.bfca028e.svg";